<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <v-icon style="cursor: pointer; user-select: none; float: right" @click="$emit('closeModal')">
        close
      </v-icon>
      <div class="coupon-info-container">
        <div class="coupon-info-container__data">
          <h2>{{ membership.name }} ({{ membership.qrcode }})</h2>
          <div>
            <h3 style="color: #666">{{ membership.membershipPlan.name }}</h3>
          </div>
          <div>
            <div>
              {{ adminText('organizationAll.status_lanstva_af22f659', 'Status članstva:') }} <strong>{{ organizationText(membershipStatus) }}</strong>
            </div>
            <div>{{ fromDateFormatted }} - {{ toDateFormatted }}</div>
          </div>
        </div>
        <div class="qrcode-and-text-container">
          <div class="qrcode-container">
            <canvas ref="qrcode" style="height: 100%; width: 100%" />
          </div>
          <main-button color="#f5f5f5" @click="downloadQrCode(membership)">
            <img src="/assets/qr.svg" :alt="adminText('organizationAll.qr_code_abba02fc', 'QR code')" style="height: 1.3125rem; width: 1.3125rem">
            <span style="color: #0277bd; margin-left: 0.5rem">{{ adminText('organizationAll.download_qr_code_e893e49d', 'DOWNLOAD QR CODE') }}</span>
          </main-button>
        </div>
      </div>
      <div class="subscriber-info-container">
        <div>
          <h3 style="color: #0277bd">{{ adminText('organizationAll.podaci_o_lanu_43d67033', 'Podaci o članu') }}</h3>
          <table class="subscriber-info-container__table text_small">
            <tr v-for="[fieldName, value] in Object.entries(membership.fields)" :key="fieldName">
              <td>{{ fieldName }}:</td>
              <td>{{ value }}</td>
            </tr>
          </table>
        </div>
        <main-button color="#f5f5f5" @click="editMembership(membership.id)">
          <span style="color: #0277bd">{{ adminText('organizationAll.edit_17865bdb', 'EDIT') }}</span>
        </main-button>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import moment from 'moment'
import QRCode from 'qrcode'

export default {
  mixins: [OrganizationLocalization],
  name: 'membership-details-modal',
  props: {
    membership: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fromDateFormatted() {
      return moment(this.membership.createdAt).format('DD.MM.YYYY.')
    },
    toDateFormatted() {
      return moment(this.membership.membershipPlan.to).format('DD.MM.YYYY.')
    },
    membershipStatus() {
      const now = moment()
      const from = moment(this.membership.membershipPlan.from)
      const to = moment(this.membership.membershipPlan.to)

      if (now.isBetween(from, to, null, '[]')) {
        return 'Aktivno'
      } else {
        return 'Neaktivno'
      }
    },
  },
  async mounted() {
    await this.generateQrCode(this.membership.qrcode)
  },
  methods: {
    async generateQrCode(value) {
      const canvas = this.$refs.qrcode

      return QRCode.toCanvas(canvas, value, {
        height: 80,
        margin: 0,
      })
    },
    downloadQrCode(membership) {
      const canvas = this.$refs.qrcode
      const link = document.createElement('a')
      link.href = canvas.toDataURL('image/png')
      link.download = `memberships-${membership.qrcode}.png`
      link.click()
    },
    async editMembership(id) {
      await this.$router.push({
        name: this.routes.sportOrganization.sportOrganizationMembersUpdate,
        params: {
          id,
        },
      })
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  max-height: 100%;
  position: relative;
  max-width: 40.75rem;
  padding: 1.5rem 1.5rem 3.25rem 1.5rem;
  border-radius: 0.75rem;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}

.coupon-info-container {
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
}

.coupon-info-container__data {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
}

h2 {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}

h3 {
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}

.text__small {
  margin: 0;
  color: #666;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.qrcode-container {
  height: fit-content;
  width: fit-content;
  padding: 1.25rem;
  border-radius: 0.625rem;
  border: 1px solid rgba(151, 151, 151, 0.5);
  background: #fff;
}

.subscriber-info-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;
  margin-top: 2rem;
}

.qrcode-and-text-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;
  gap: 1rem;
}

@media screen and (max-width: 550px) {
  .subscriber-info-container {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .coupon-info-container {
    flex-direction: column;
    gap: 0.5rem;
  }

  .qrcode-and-text-container {
    align-items: flex-start;
  }
}

.subscriber-info-container__table {
  margin-top: 1.25rem;
}

.all-tickets-container,
.monthly-tickets-container {
  border-top: 1px solid #d9d9d9;
  padding-top: 0.75rem;
  display: flex;
  justify-content: space-between;
  gap: 2.5rem;
}

.tickets-numbers-icon-container {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.tickets-numbers-text {
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}

.scanned-ticket-container {
  display: flex;
  gap: 0.5rem;
}

.usage-text {
  color: #979797;
  text-align: right;
  font-family: 'Source Sans Pro';
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.additional-items-title-container {
  display: flex;
  gap: 2.5rem;
  border-top: 1px solid #d9d9d9;
  padding-top: 0.75rem;
  margin-top: 1rem;
  justify-content: space-between;
}

.body__small {
  color: #666;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.send-status-container {
  display: flex;
  margin-top: 0.62rem;
}

.send-status-container_data {
  display: flex;
  gap: 0.75rem;
  flex: 1;
}

::v-deep .v-input--radio-group__input {
  display: flex;
  flex-direction: row;
  margin-top: 0 !important;
  padding-top: 0 !important;
}

::v-deep .radio-group-container {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.divider {
  border-top: 1px solid #d9d9d9;
  margin-top: -1rem;
}

.custom-radio-label {
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}
</style>
